import React from "react";
import "./WeekSelector.css";
import * as t from "./types";

// this is a left-sidebar master (from master-detail) for selecting which week calendar to show
// there will be a callback prop to notify which week to render.

interface WeekSelectorProps {
  activeWeek: t.IWeek;
  weeks: t.IWeek[];
  weekSelected: (w: t.IWeek) => void;
}

export const WeekSelector = (props: WeekSelectorProps) => {
  //console.log('WeekSelector');
  //console.log(props);
  const { activeWeek, weeks, weekSelected } = props;
  return (
    <div className="topbar">
      <h3 className="week-header">Woche Auswählen</h3>
      {weeks.map((w) => {
        return (
          <button
            className={
              w === activeWeek ? "week-button active-week" : "week-button"
            }
            onClick={() => weekSelected(w)}
          >
            {w.name}
          </button>
        );
      })}
    </div>
  );
};
